import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppThunk, RootState } from "./store";
import { BalanceService } from "../services/BalanceService";
import { WalletService } from "../services/WalletService";

interface BalanceState {
    list: Array<any>,
    balance: Array<any>,
    amount: any,
    wallet: Array<any>,
    selectedUserId: number | null
    clientListBalances: Array<any>
}

const initialState: BalanceState = {
    list: [],
    balance: [],
    amount: null,
    wallet: [],
    selectedUserId: null,
    clientListBalances: []
};

const balanceSlice = createSlice({
    name: 'balance',
    initialState,
    reducers: {
        setBalances: (state, action: PayloadAction<Array<any>>) => {
            state.list = action.payload;
        },
        setBalancesByOrganization: (state, action: PayloadAction<Array<any>>) => {
            state.balance = action.payload;
        },
        setWalletByOrganization: (state, action: PayloadAction<any>) => {
            state.wallet = action.payload;
        },
        setSelectedUserIdForBalance: (state, action: PayloadAction<number>) => {
            console.log(action.payload);
            state.selectedUserId = action.payload;
        },
        setClientBalances: (state, action: PayloadAction<any>) => {
            state.clientListBalances = action.payload;
        },
        resetBalanceState: (state) => {
            state.selectedUserId = null;
            state.clientListBalances = [];
        },
    }
  });
  
export const {
    setBalances, 
    setBalancesByOrganization, 
    setWalletByOrganization,
    setSelectedUserIdForBalance,
    setClientBalances,
    resetBalanceState
} = balanceSlice.actions;

// customs func
export const getAllBalanceList = (state: RootState): object => state.balance.list;
export const getWalletByOrganization = (state: RootState): any => state.balance.wallet;
export const getClientBalances = (state: RootState): any => state.balance.clientListBalances;

export const getAllBalance =  () : AppThunk<Promise<void>> => async (dispatch) => {
  const all : any = await BalanceService.getAllBalances();
  dispatch(setBalances(all))
}

export const getBalanceByOrganization = (id:number|null) : AppThunk<Promise<void>> => async (dispatch) => {
    try {
        const organizationBalance : any = await BalanceService.getBalanceByOrganization(id);
        const organizationBalanceFiltered = organizationBalance.filter(
            (item:any) => item.direction !== 'CREATION'
        );
        dispatch(setBalancesByOrganization(organizationBalanceFiltered));
    } catch (e) {
        console.error(e);
    }
}

export const fetchWalletByOrganization = (id:number|null) : AppThunk<Promise<void>> => async (dispatch) => {
    try {
        const walletOrganization : any = await WalletService.getWalletByOrganization(id);
        const ordered = [...walletOrganization].sort((a, b) => {
            return a.asset.name.toLowerCase() === 'brl' ? -1 : b.asset.name.toLowerCase() === 'brl' ? 1 : 0
        });
        dispatch(setWalletByOrganization(ordered))
    } catch (e) {
        console.error(e);
    }
}

export const fetchOrganizationBalances = (range:any)  : AppThunk<Promise<void>> => async (dispatch, getState) => {
    try {

        const s = getState().balance;
        if(!s.selectedUserId) throw new Error("Bad request, missing client Id");

        const organizationBalances : any = await BalanceService.getOrganizationsBalances(range, s.selectedUserId);
        dispatch(setClientBalances(organizationBalances));

    } catch (e) {
        console.error(e);
    }
}


export default balanceSlice.reducer;